module.exports = "/images/arrow-bg.png?841faac651b40d60bb113e51af65960e";